import { CheckIcon } from '@heroicons/react/24/outline';
import type { ChipOption } from './chipPresets';

interface ChipOptionListProps<TId extends string> {
    options: readonly ChipOption<TId>[];
    selected: TId;
    onSelect: (id: TId) => void;
}

export function ChipOptionList<TId extends string>({
    options,
    selected,
    onSelect
}: ChipOptionListProps<TId>) {
    return (
        <ul className="flex flex-col">
            {options.map((option) => {
                const isSelected = option.id === selected;
                return (
                    <li key={option.id}>
                        <button
                            type="button"
                            aria-pressed={isSelected}
                            onClick={() => onSelect(option.id)}
                            className={`flex h-8 w-full items-center justify-between gap-3 rounded-md px-2.5 text-left text-[13px] hover:bg-gray-50 focus:outline-none focus-visible:bg-gray-100 ${
                                isSelected ? 'font-semibold text-gray-900' : 'text-gray-700'
                            }`}
                        >
                            {option.label}
                            {isSelected && (
                                <CheckIcon
                                    className="h-4 w-4 shrink-0 text-gray-900"
                                    aria-hidden="true"
                                />
                            )}
                        </button>
                    </li>
                );
            })}
        </ul>
    );
}
